import React, { useEffect, useState, useCallback } from "react";
import "./CategoriesList.scss";
import TableComponent from "../../../components/TableComponent/TableComponent";
import { Button } from "antd";
import AddCategory from "../../../components/CategoriesComponents/AddCategory/AddCategory";
import ToastHelper from "../../../services/ToastHelper";
import { postApi } from "../../../utils/apiServices";
import { ADD_CATEGORY, GET_CATEGORIES_LIST } from "../../../utils/apiPath";
import { IMAGE_BASE_PATH } from "../../../utils/constant";
import { useNavigate } from "react-router-dom";

const breadcrumbLabels = ["Categories", "SubCategories", "SubSubCategories"];

const CategoriesList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [currentLevel, setCurrentLevel] = useState("categories");
  const [selectedParentIds, setSelectedParentIds] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editData, setEditData] = useState(null);

  const handleAdd = () => {
    navigate('/manage/category/add');
  };

  const handleEditCategory = (id) => {
    navigate(`/manage/category/edit/${id}`);
  };

  const handleViewSubCategories = (categoryId) => {
    navigate(`/manage/category/${categoryId}/sub-category`);
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "media",
      sorter: true,
      render: (media) => (
        <div style={{ width: "60px", height: "60px" }}>
          <img
            style={{ width: "60px", height: "60px", borderRadius: "8px" }}
            src={`${IMAGE_BASE_PATH}${media?.url}`}
            alt={media?.altText}
          />
        </div>
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      sorter: true,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <Button onClick={() => handleViewSubCategories(record?.id)}>
            👁️ View
          </Button>
          <Button onClick={() => handleEditCategory(record.id, currentLevel)}>
          🏀 Edit
          </Button>
        </div>
      ),
    },
  ];

  const fetchCategories = async (parentId) => {
    const payload = {
      pageIndex: pagination.current - 1,
      pageSize: pagination.pageSize,
      searchString: "",
      parentCategoryId: parentId ?? 0,
    };
    try {
      const res = await postApi(GET_CATEGORIES_LIST, payload);

      if (res?.data?.length !== 0) {
        // ToastHelper.success("success");
        return res;
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      // ToastHelper.error(
      //   "Failed to connect to the server. Please try again later."
      // );
    } finally {
      setIsLoading(false);
    }
    return null;
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    const result = await fetchDataByLevel(
      currentLevel,
      selectedParentIds[selectedParentIds?.length - 1],
      pagination
    );
    setData(result?.data);
    setPagination((prev) => ({ ...prev, total: result?.totalRecords }));
    setLoading(false);
  }, [
    currentLevel,
    selectedParentIds,
    pagination.current,
    pagination.pageSize,
    !showForm,
  ]);

  const fetchDataByLevel = async (level, parentId, pagination) => {
    switch (level) {
      case "categories":
        return fetchCategories(parentId);
      case "subcategories":
        return fetchCategories(parentId);
      case "subsubcategories":
        return fetchCategories(parentId);
      default:
        return { data: [], total: 0 };
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleTableChange = (newPagination, filters, sorter) => {
    setPagination(newPagination);
  };

  const handleEyeClick = (id, level) => {
    const newSelectedIds = [...selectedParentIds];

    if (level === "categories") {
      newSelectedIds[0] = id;
      setCurrentLevel("subcategories");
    } else if (level === "subcategories") {
      newSelectedIds[1] = id;
      setCurrentLevel("subsubcategories");
    } else if (level === "subsubcategories") {
      newSelectedIds[2] = id;
    }

    setSelectedParentIds(newSelectedIds);
  };

  // const handleEditClick = (id, level) => {
  //   const edit = data?.find((cat) => cat?.id === id);
  //   setEditData(edit);
  //   setShowForm(!showForm);
  // };

  const handleBreadcrumbClick = (levelIndex) => {
    const levels = ["categories", "subcategories", "subsubcategories"];
    setCurrentLevel(levels[levelIndex]);
    setSelectedParentIds(selectedParentIds.slice(0, levelIndex));
  };

  const handleForm = () => {
    setShowForm(!showForm);
    setEditData(null);
  };
  

  const handleAddCategory = async (data, file, schemas) => {
    const payload = {
      title: data?.title,
      description: data?.description,
      metaTitle: data?.meatTitle,
      metaDescription: data?.metaDescription,
      urlName: data?.pageUrl,
      schema: schemas,
      media: {
        altText: data?.altText,
        media: file?.split(",")[1],
      },
      parentCategoryId: selectedParentIds[selectedParentIds?.length - 1] ?? 0,
    };

    try {
      const { statusCode, data, message, error } = await postApi(
        ADD_CATEGORY,
        payload
      );

      if (statusCode === 200) {
        ToastHelper.success("success");
        // handleForm();
      } else if (statusCode === 400) {
        ToastHelper.error(
          error || message || "An error occurred. Please try again."
        );
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      ToastHelper.error(
        "Failed to connect to the server. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="categories">
      <div className="categories_container">
        <div className="categories_header">
          {!showForm ? (
            <div className="categories_header_left">
              <span className="active">Collections</span>
              {/* {breadcrumbLabels
                .slice(0, selectedParentIds.length + 1)
                .map((label, index) => {
                  const active = index === selectedParentIds.length;
                  return (
                    <span
                      key={index}
                      className={`${active ? "active" : ""}`}
                      onClick={
                        active ? null : () => handleBreadcrumbClick(index)
                      }
                    >
                      {label}
                      {index < selectedParentIds.length && " / "}
                    </span>
                  );
                })} */}
            </div>
          ) : (
            <div className="categories_header_left">
              <span className="active">Add collection</span>
            </div>
          )}
          <div className="categories_header_right">
            {/* {!showForm ? ( */}
              <Button type="primary" onClick={handleAdd}>
                Add {currentLevel}
              </Button>
            {/* ) : (
              <Button onClick={handleForm}>Back to {currentLevel} list</Button>
            )} */}
          </div>
        </div>
        {!showForm ? (
          <TableComponent
            columns={columns}
            data={data}
            pagination={pagination}
            loading={loading}
            onTableChange={handleTableChange}
          />
        ) : (
          <AddCategory
            currentLevel={currentLevel}
            onSubmit={handleAddCategory}
            isLoading={isLoading}
            editData={editData}
          />
        )}
      </div>
    </div>
  );
};

export default CategoriesList;
